import {request} from '@/helpers/apiClient'
import {UPLOAD_IMAGES_CONFIG} from '@/utils/constants/apiConfig/uploadImagesConfig'

export const uploadImagesService = options => {
  const formData = options?.formData

  if (formData) {
    const metadata = formData.get('metadata')

    if (metadata) {
      try {
        const metadataObj = JSON.parse(metadata)
        const referenceEntity = metadataObj?.mediaUploadMetadata?.[0]?.referenceEntity

        if (referenceEntity === 'promotion') {
          return request(UPLOAD_IMAGES_CONFIG.UPLOAD_PROMOTION_IMAGES(), options)
        }
      } catch (err) {
        // metadata is not valid JSON
        console.warn('Invalid metadata JSON', err)
      }
    }
  }
  return request(UPLOAD_IMAGES_CONFIG.UPLOAD_IMAGES(), options)
}
